export default {
  common: {
    empty: "No data",
  },
  nav: {
    home: "Home",
    explore: "Explore Publications",
    openAccess: "Open Access Articles",
    about: "About Us",
    searchPlaceholder: "Search publications/authors...",
  },
  home: {
    statPublications: "Publications",
    statAuthors: "Authors",
    statDownloads: "Downloads",
    exploreTitle: "Explore Publications",
    bookRecommend: "Book Recommendations",
    videoTitle: "Author Videos",
    authorIntro: "Author Bio",
    authorSuffix: " Ed.",
    more: "More",
    authorBioEn: "Fung Yee-wang holds a Bachelor of Arts and a Master of Education from the University of Hong Kong. He has served as the Master-in-Charge of Extracurricular Sports at the Diocesan Boys' School, Warden of May Hall and Lecturer in the Department of Education at the University of Hong Kong (HKU), and Senior Lecturer and Chair of the Department of Curriculum and Instruction at the Faculty of Education of the Chinese University of Hong Kong (CUHK). Following his retirement, he was appointed by CUHK as a part-time Executive Director of the Centre for University and School Partnership, as well as an Honorary Associate Professor. Mr. Fung has been dedicated to the field of education for many years, specializing in geography education, extracurricular activities, and student sports. He also possesses extensive experience and profound insights into the teaching of Chinese Language and Chinese History in secondary schools.",
  },
  about: {
    missionBtn: "Open Access at CityUHK Press",
    openAccessBtn: "Copyright",
    missionTitle: "Open Access at the City University of Hong Kong Press",
    missionContent:
      'Founded in 1996, City University of Hong Kong Press celebrates its 30th anniversary this year. To navigate rapid shifts in academic publishing and meet evolving community needs, we have launched <span class="brand-color">innOAccess</span>.\n\nThis new Open Access (OA) platform for all newly published academic works is developed by CNKI, the largest platform for the dissemination of academic resources in China. It provides free, immediate access to our online publications.',
    openAccessTitle: "Copyright",
    openAccessContent:
      'All books on this platform are licensed under a Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International License (<a href="https://creativecommons.org/licenses/by-nc-nd/4.0/" target="_blank" class="license-link">CC BY-NC-ND 4.0</a>). You may copy and distribute the materials in any medium or format, with appropriate credit to the authors, in their original form, and for non-commercial purposes.',
  },
  privacy: {
    title: "Privacy Policy",
    statementTitle: "Privacy Policy Statement",
    statementContent:
      'City University of Hong Kong ("the University") is committed to safeguarding personal data principles in its data management policy and practices, and complies with Hong Kong\'s Personal Data (Privacy) Ordinance. The University has issued the <a href="#" class="text-link">Code of Practice on Personal Data (Privacy) Issues</a> (the <a href="#" class="text-link">"Code of Practice"</a>) to provide guidance to staff on the collection, holding and use of personal data records. Such personal data records include those of teaching staff, students, alumni and individuals who apply to the University for employment or admission.\n\nWhere the University collects identifiable personal data from you in electronic or paper form, the purposes for collecting such data will be explained. Personal data collected from you will be kept confidential and transferred only to relevant departments for the purposes specified in the Code of Practice. The University has also made administrative arrangements to allow you to request access to and correction of your personal data held by the University.',
    cookieTitle: "Cookie Policy",
    cookieContent:
      "City University of Hong Kong uses 'cookies' and 'page tagging' to record browsing data of our website, but does not collect any personally identifiable information. Such browsing data is collected, stored and processed by the University or its selected third-party service providers for compiling website usage statistics, tracking the performance of our social media messages and online advertisements.",
    sessionTitle: "Cookies",
    sessionContent:
      "Cookies are small pieces of data created by the internet browser when a user visits a webpage, typically containing an anonymous unique identifier. Such cookies can be used to identify the computer, but do not collect any personal information. In other words, cookies do not identify the individual user browsing the website. CityU uses cookies to store user preferences, record statistics of users browsing CityU webpages, and analyse user habits. In some cases CityU may use the collected user habits for third-party website advertising. You may accept or reject cookies in your browser settings. If you choose to reject, you may not be able to use certain functions of the CityU website.",
    pageTagTitle: "Page Tagging",
    pageTagContent:
      "We use page beacons, pixels and remarketing tags to collect and analyse statistics on users' use of CityUHK webpages, and to track the effectiveness of our online advertising. Some of our webpages contain images that indicate the use of these technologies to collect user activity data. After data analysis, we measure the effectiveness of our webpages and online advertising for improvement. These technologies do not collect personally identifiable information. If you wish to disable such tracking, you may disable cookies in your internet browser. To restrict tracking, you may also browse our webpages in private/incognito mode, or install tools and add-ons that block such tracking.",
  },
  disclaimer: {
    title: "Disclaimer",
    content:
      "All information provided on this website is subject to revision and periodic review. If you have questions about such information, or believe that your copyright has been infringed, or wish to remove hyperlinks to your web pages, please notify the website administrator:",
    email: "upress@cityu.edu.hk",
  },
  footer: {
    explore: "Explore Publications",
    openAccess: "Open Access Articles",
    about: "About Us",
    disclaimer: "Disclaimer",
    privacy: "Privacy Policy",
    copyright: "© 2026 City University of Hong Kong. All Rights Reserved.",
  },
  explore: {
    sortBy: "Sort:",
    sortPublishDate: "Publication date",
    prevPage: "Prev",
    nextPage: "Next",
  },
  search: {
    resultPrefix: "Search results: ",
    resultCountPrefix: "",
    resultCountSuffix: " results",
  },
  bookDetail: {
    detail: "Book Detail",
    author: "Author",
    publishDate: "Publication date",
    pages: "Pages",
    introduction: "Introduction",
    downloadEbook: "Download E-Book",
    purchasePaperBook: "Purchase printed copy",
    authorIntro: "Author Bio",
    relatedBooks: "Related Books",
    editorSingle: ' Ed.',
    editorPlural: ' Eds.',
  },
  articleDetail: {
    researchTopic: "Research Topic: ",
    journal: "Academic Journal",
    author: "Author: ",
    publishDate: "Publication date",
    pageViews: "Article Views: ",
    viewsSuffix: " views",
    abstract: "Abstract",
    downloadPDF: "View Full Text PDF",
    relatedArticles: "Related Articles",
  },
  authors: {
    title: "Authors",
    sortLabel: "Sort by: ",
    sortStroke: "By stroke order",
    sortPinyin: "By alphabetical",
    sortPublications: "By Publication Number",
  },
  categoryNames: {
    "文學、歷史與文化研究": "Literature, History, and Cultural Studies",
    "文學": "Literature",
    "歷史": "History",
    "文化研究": "Cultural Studies",

    "社會科學、教育與公共服務": "Social Sciences, Education, and Public Service",
    "社會工作": "Social Work",
    "教育": "Education",
    "科學": "Science",
    "工程及建築": "Engineering and Architecture",

    "商業、經濟與創業": "Business, Economics, and Entrepreneurship",
    "經濟": "Economics",
    "財務金融及會計": "Finance and Accounting",
    "市場行銷": "Marketing",
    "創業及經營": "Entrepreneurship and Business Management",
    "生涯規劃": "Career Planning",

    "公共事務與法律": "Public Affairs and Law",
    "公共事務與管理": "Public Affairs and Governance",
    "法律": "Law",

    "語言、翻譯與傳播": "Languages, Translation, and Communications",
    "外語學習": "Language Learning",
    "語文及翻譯": "Language and Translation",
    "媒體及傳播": "Media and Communications",

    "傳記、與特定主題": "Biography and Special Topics",
    "人物傳記": "Biographies and Autobiographies",
    "特定主題": "Special Topics",

    "其他": "Other",
  },
  authorDetail: {
    title: "Author Bio",
    publishedBooks: "Published Books",
  },
  openAccess: {
    hotTopicLabel: "Hot Topics",
    topicCategory: "Topics Classification",
    disciplineCategory: "Disciplines",
    totalArticles: "Showing page 1, {count} results in total",
    list: {
      researchTopic: "Research Topic: ",
      researcher: "Researchers: ",
      disciplinaryField: "Discipline: ",
      publicationDate: "Publication date",
      abstract: "Abstract: ",
      sortRelevance: "Relevance",
      sortPublicationDate: "Publication Date",
    },
  },
};
